import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalData } from '../types/modal-data.model';

@Component({
    selector: 'app-modal',
    imports: [MatDialogContent, MatIconModule, MatDialogModule, CommonModule],
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
    private dialogRef: MatDialogRef<ModalComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
